module.exports = __webpack_public_path__ + "static/img/product_banner.1fe86d8.jpeg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/home/product_banner.jpeg
// module id = j8Wo
// module chunks = 2